module.exports = __webpack_public_path__ + "media/src/images/icon_detail-5971d6b5d2f2d98b667ef265da1f60b7.png";